import type { ReactNode } from 'react'
import { useHydrated } from './useHydrated'

interface ClientOnlyProps {
  /** Rendered during the prerender and hydration (e.g. a page loader) */
  fallback?: ReactNode
  /**
   * Function child so the client-only tree is never evaluated during the prerender —
   * required when children reference browser-only SDKs.
   */
  children: () => ReactNode
}

// AIDEV-NOTE: prerender; gate for subtrees that must never render at build time (Auth0
// redirects, Stripe/HelloSign SDKs, per-visitor state). Pair with React.lazy when the child's
// module graph itself crashes on Node import (e.g. hellosign-embedded).
export function ClientOnly({ fallback = null, children }: ClientOnlyProps) {
  return useHydrated() ? <>{children()}</> : <>{fallback}</>
}
